import {getAPIGatewayDataFromParent, getNodeCapabilityFromParent} from "../handler/ParentDataHandler";
import {
    chainWalk,
    getAliasFromLoginId,
    getClusterForAisle,
    getFormattedTimeFromEpoch,
    getZoneForCartLocation
} from "../Utility";
import {publishCount, publishTime} from "../MetricUtility";
import {ERROR_METRIC_SUFFFIX} from "../constants";
import {Capability, Resource} from "../enums";

const metricProcessName = "SCC_STOW";

export async function getAtRiskAislesMetrics(request) {
    const metricName = "getStowOverviewMetrics";
    const args = getAPIGatewayPostRequest(request, "svs/aislesHeatMap/metrics");
    const startTime = Date.now();
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        publishTime(metricProcessName, metricName, startTime);
        return transformAtRiskAislesMetrics(response.data.groupedAisleMetrics);
    }
    publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
}

export async function getNodeResourceData(request) {
    const metricName = "getNodeResourceData";
    const args = getAPIGatewayPostRequest(request, "svs/nodeResource/data");
    const startTime = Date.now();
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        publishTime(metricProcessName, metricName, startTime);
        return transformNodeResourceMetrics(response.data.nodeResourceList, response.data.nodeResourceType)
    }
    publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
}

export async function getStowPackageMetrics(request) {
    const metricName = "getStowPackageMetrics";
    const args = getAPIGatewayPostRequest(request, "svs/packages/metrics");
    const startTime = Date.now();
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        publishTime(metricProcessName, metricName, startTime);
        return transformStowPackageMetrics(response.data.packageMetricsGroupList, response.data.aggregatePackageMetrics);
    }
    publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
}

export async function getStowRoutes(request) {
    const metricName = "getStowRoutes";
    const args = getAPIGatewayPostRequest(request, "svs/routes/data");
    const startTime = Date.now();
    const response = await getAPIGatewayDataFromParent(args);

    if (response.status === 200) {
        publishTime(metricProcessName, metricName, startTime);
        return transformStowRoutes(response.data.routes);
    }
    publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);


    function transformStowRoutes(routes) {
        const routesMap = {};
        routes.forEach(route => (
            routesMap[route.id] = {
                routeCode: route.code,
                plannedPackages: route.plannedCount
            }
        ));
        return routesMap;
    }

}

export async function getStowBinMetrics(request) {
    const metricName = "getStowBinMetrics";
    const args = getAPIGatewayPostRequest(request, "svs/bins/metrics");
    const startTime = Date.now();
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        publishTime(metricProcessName, metricName, startTime);
        return transformStowBinMetrics(response.data.groupedBinMetrics);
    }
    publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
}

export async function getStowBinMetricsForStowV2(request) {
    const metricName = "getStowBinMetrics";
    const args = getAPIGatewayPostRequest(request, "svs/bins/metrics");
    const startTime = Date.now();
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        publishTime(metricProcessName, metricName, startTime);
        return transformStowBinMetricsForStowV2(response.data.groupedBinMetrics);
    }
    publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
}

export async function getStowBagMetrics(request) {
    const metricName = "getStowBagMetrics";
    const args = getAPIGatewayPostRequest(request, "svs/bags/metrics");
    const startTime = Date.now();
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        publishTime(metricProcessName, metricName, startTime);
        return transformStowBagMetrics(response.data.groupedBagMetrics);
    }
    publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
}

export async function getStowCartMetrics(request) {
    const metricName = "getStowCartMetrics";
    const args = getAPIGatewayPostRequest(request, "svs/carts/metrics");
    const startTime = Date.now();
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        publishTime(metricProcessName, metricName, startTime);
        return transformStowCartMetrics(response.data.groupedCartMetrics);
    }
    publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
}

export async function getStowAssociateMetrics(request) {
    const metricName = "getStowAssociateMetrics";
    const args = getAPIGatewayPostRequest(request, "svs/associates/metrics");
    const startTime = Date.now();
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        publishTime(metricProcessName, metricName, startTime);
        return transformStowAssociateMetrics(response.data.associateMetricsGroupList);
    }
    publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
}

export async function getStowFloorMetrics(request) {
    const args = getAPIGatewayPostRequest(request, "svs/floors/metrics");
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        return transformStowFloorMetricsGroupMap(response.data.floorMetricsGroupList);
    }
}

export async function getStowBins(request) {
    const metricName = "getStowBins";
    const args = getAPIGatewayPostRequest(request, "svs/bins/data");
    const startTime = Date.now();
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        publishTime(metricProcessName, metricName, startTime);
        return transformBins(response.data.bins);
    }
    publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
}

export async function getStowCarts(request) {

    const args = getAPIGatewayPostRequest(request, "svs/carts/data");
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        return transformCarts(response.data.carts);
    }
}

export async function getStowFloors(request) {

    const args = getAPIGatewayPostRequest(request, "svs/floors/data");
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        return transformFloors(response.data.floors);
    }
}

export async function getStowAssociates(request) {
    const metricName = "getStowAssociates";
    const args = getAPIGatewayPostRequest(request, "svs/associates/data");
    const capability = await getNodeCapability()
    const startTime = Date.now();
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        publishTime(metricProcessName, metricName, startTime);
        return transformAssociatesList(response.data.associates, capability);
    }
    publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
}

export async function getStowAssociateScanMetrics(request) {
    const metricName = "getStowAssociateScanMetrics";
    const args = getAPIGatewayPostRequest(request, "svs/associates/scanMetrics");
    const startTime = Date.now();
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        publishTime(metricProcessName, metricName, startTime);
        return response.data;
    }
    publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
}

const getNodeCapability = async () => {
    const capabilityResponse = await getNodeCapabilityFromParent()
    return JSON.parse(capabilityResponse.capability);
}

export async function getStowFilters(nodeId) {
    const metricName = "getStowFilters";
    const args = getAPIGatewayGetRequest({nodeId: [nodeId]}, "svs/getFiltersForStow");
    const startTime = Date.now();
    const response = await getAPIGatewayDataFromParent(args);
    const capability = await getNodeCapability()
    if (response.status === 200) {
        publishTime(metricProcessName, metricName, startTime);
        return transformStowFilters(response.data.filterMap, capability);
    }
    publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
}
function getCPTDataAPIGatewayRequest(request) {
    return {
        resourcePath: "/svs/getStationCPTs",
        httpMethod: "post",
        processName: "stow",
        requestBody: request
    }
}

export async function getCPTList(nodeId) {
    const request = {
        nodeId: [nodeId],
    }
    const metricName = "getCPTList";
    const args = getCPTDataAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            publishTime(metricProcessName, metricName, startTime);
            const output = result.data;
            let data= JSON.parse(output.CPTList)
            return {CPTList: data, CPTLabel: output.CPTTypeLabelKey, filterIdentifier: output.filterIdentifier};
        }
    });
}

export async function getPackages(request) {
    const metricName = "getStowPackages";
    const args = getAPIGatewayPostRequest(request, "svs/packages/data");
    const startTime = Date.now();
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        publishTime(metricProcessName, metricName, startTime);
        return transformPackages(response.data.packages);
    }
    publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
}

function getAPIGatewayPostRequest(request, resourcePath) {
    return {
        resourcePath: resourcePath,
        httpMethod: "post",
        processName: "stow",
        requestBody: request
    }
}

function getAPIGatewayGetRequest(request, resourcePath) {
    return {
        resourcePath: resourcePath,
        httpMethod: "get",
        processName: "stow",
        requestParams: request
    }
}


function transformAssociatesList(associates, capability) {
    return associates.map(associate => (
        {
            alias: associate.alias,
            name: associate.name,
            active: isAssociateActive(associate.status),
            location: associate.location,
            cluster: getCluster(associate.location, capability),
            pph: associate.performance.pph === -1 ? '-': associate.performance.pph,
            fsaf: associate.performance.fsaf,
            fsafDpmo: associate.performance.fsafDpmo,
            stowedPackages: associate.performance.stowedCount,
            stowedBufferedPackages: associate.performance.stowBufferedCount,
            minutesWorked: associate.performance.minutesWorked
        })
    );
}

function getCluster(location, capability) {
    if(Capability.AMZL === capability) {
        return getClusterForAisle(location)
    } else if(Capability.SSD === capability) {
        return getZoneForCartLocation(location)
    }
}

function transformBags(bags) {
    return bags.map(bag => (
        {
            bagLabel: bag.label,
            state: bag.open ? "Open": "Closed",
            childCount: bag.childCount
        }
    ))
}

function transformBins(bins) {
    return bins.map(bin => (
        {
            binLabel: bin.binLabel,
            bags: transformBags(bin.bags),
            ovUsage: bin.ovUsage.toFixed(2)
        }
    ))
}

function transformCart(cart) {
    return {
        readiness: (cart.readiness*100).toFixed(2),
        status: cart.status,
        childCount: cart.childCount,
        label: cart.label,
        type: cart.type,
        packageCount: cart.packageCount,
        bins: cart.bins && transformBins(cart.bins)
    }
}

function transformCarts(carts) {
    return carts.map(cart => transformCart(cart))
}

function transformFloors(floors) {

    const floorEntries = floors.map(floor => (
        {
            [floor.label]: {
                routeCode: floor.routeCode,
                routeId: floor.routeId,
                cart: floor.cart && transformCart(floor.cart)
            }
        }
    ))

    return Object.assign({}, ...floorEntries);
}

function transformPackages(packages) {
    return packages.map(packageObject => (
        {
            trackingId: packageObject.trackingId,
            lastScan: getFormattedTimeFromEpoch(packageObject.localLastScanTime * 1000),
            minutesInState: packageObject.minutesInState,
            state: packageObject.state,
            reason: packageObject.reason,
            location: packageObject.sortLocation.location,
            associateId: getAliasFromLoginId(packageObject.lastScanAssociateId),
            cycle: packageObject.cycleId,
            sortZone: packageObject.sortLocation.bin,
            cluster: packageObject.sortLocation.cluster,
            ead: getFormattedTimeFromEpoch(packageObject.localEstimatedArrivalDate * 1000),
            size: packageObject.size,
            routeCode: packageObject.routeCode,
            floor: packageObject.sortLocation.floor,
            conveyance: packageObject.sortLocation.conveyance
        })
    );
}

function isAssociateActive(status) {
    return status === "ACTIVE" ? "Yes" : "No";
}

function transformAtRiskAislesMetrics(groupedAisleMetrics) {
    const metricsMapOutput = {};
    for (const key in groupedAisleMetrics) {
        if (key) {
            metricsMapOutput[key] = {
                associateAlias:   groupedAisleMetrics[key]["activeAssociateAliases"],
                activeStowers:    groupedAisleMetrics[key]["activeAssociateCount"],
                currentStowedPackages: groupedAisleMetrics[key]["currentStowedCount"],
                isAtRisk: groupedAisleMetrics[key]["isAtRisk"],
                minutesOfWork: groupedAisleMetrics[key]["minutesOfWork"],
                adjacencyScore: groupedAisleMetrics[key]["adjacencyScore"],
                baselineAdjacencyScore: groupedAisleMetrics[key]["baselineAdjacencyScore"]
            };
        }
    }
    return metricsMapOutput;
}

function transformNodeResourceMetrics(nodeResourceDataList, nodeResourceDataType) {
    const nodeResourceMapOutput = {};
    for( const nodeResource of nodeResourceDataList) {
        let resource = nodeResource.nodeResourceLabel;
        nodeResourceMapOutput[resource] ={
            displayLabel: resource,
            numberOfSortZones: nodeResource.numberOfSortZones
        };
    }
    return nodeResourceMapOutput;
}

function transformStowPackageMetrics(packageMetricsGroupList, aggregatePackageMetrics) {
    const metricsMapOutput = {};
    for (const packageMetricsGroup of packageMetricsGroupList) {
        metricsMapOutput[packageMetricsGroup.id] = {
            displayLabel: packageMetricsGroup.displayLabel,
            plannedPackages: chainWalk(() => packageMetricsGroup.packageMetrics.plannedCount, null),
            stowedPackages: chainWalk(() => packageMetricsGroup.packageMetrics.stowedCount, null),
            currentInductedPackages: chainWalk(() => packageMetricsGroup.packageMetrics.currentInductedCount, null),
            currentStowedPackages: chainWalk(() => packageMetricsGroup.packageMetrics.currentStowedCount, null),
            currentStowBufferedPackages: chainWalk(() => packageMetricsGroup.packageMetrics.currentStowBufferedCount, undefined),
            currentMFRJackpotBufferedPackages: chainWalk(() => packageMetricsGroup.packageMetrics.currentMFRJackpotBufferedCount, undefined),
            problemSolvePackages: chainWalk(() => packageMetricsGroup.packageMetrics.problemSolveCount, null),
            minutesOfWork: chainWalk(() => (packageMetricsGroup.packageMetrics.minutesOfWork === 0 && packageMetricsGroup.packageMetrics.currentInductedCount !== 0) ? '-' : packageMetricsGroup.packageMetrics.minutesOfWork, null),
            stowRate: chainWalk(() => packageMetricsGroup.packageMetrics.stowRate, null),
            lastFifteenMinuteStowRate: chainWalk(() => packageMetricsGroup.packageMetrics.lastFifteenMinuteStowRate, null),
            stowVsPlan: chainWalk(() => packageMetricsGroup.packageMetrics.stowVsPlan.toFixed(2), null),
            scanCompliance: chainWalk(() => packageMetricsGroup.packageMetrics.scanCompliance.toFixed(2), null),
            currentScanCompliance: chainWalk(() => packageMetricsGroup.packageMetrics.currentScanCompliance.toFixed(2), null),
            fsaf: chainWalk(() => packageMetricsGroup.packageMetrics.fsaf, null)
        };
    }

    metricsMapOutput['Total'] = {
        displayLabel: 'Total',
        plannedPackages: chainWalk(() => aggregatePackageMetrics.plannedCount, null),
        stowedPackages: chainWalk(() => aggregatePackageMetrics.stowedCount, null),
        currentInductedPackages: chainWalk(() => aggregatePackageMetrics.currentInductedCount, null),
        currentStowBufferedPackages: chainWalk(() => aggregatePackageMetrics.currentStowBufferedCount, undefined),
        currentMFRJackpotBufferedPackages: chainWalk(() => aggregatePackageMetrics.currentMFRJackpotBufferedCount, undefined),
        currentStowedPackages: chainWalk(() => aggregatePackageMetrics.currentStowedCount, null),
        problemSolvePackages: chainWalk(() => aggregatePackageMetrics.problemSolveCount, null),
        minutesOfWork: chainWalk(() => (aggregatePackageMetrics.minutesOfWork === 0 && aggregatePackageMetrics.currentInductedCount !== 0) ? '-' : aggregatePackageMetrics.minutesOfWork, null),
        stowRate: chainWalk(() => aggregatePackageMetrics.stowRate, null),
        lastFifteenMinuteStowRate: chainWalk(() => aggregatePackageMetrics.lastFifteenMinuteStowRate, null),
        stowVsPlan: chainWalk(() => aggregatePackageMetrics.stowVsPlan.toFixed(2), null),
        scanCompliance: chainWalk(() => aggregatePackageMetrics.scanCompliance.toFixed(2), null),
        currentScanCompliance: chainWalk(() => aggregatePackageMetrics.currentScanCompliance.toFixed(2), null),
        fsaf: chainWalk(() => aggregatePackageMetrics.fsaf, null)
    }
    return metricsMapOutput
}

function transformStowBinMetrics(metricsMapInput) {
    const metricsMapOutput = {};
    for (const key in metricsMapInput) {
        metricsMapOutput[key] = {
            binsMissingBag: metricsMapInput[key].binsCountMissingOpenBag,
        };
    }
    return metricsMapOutput;
}

function transformStowBinMetricsForStowV2(metricsMapInput) {
    const metricsMapOutput = {};
    for (const key in metricsMapInput) {
        metricsMapOutput[key] = {
            binsMissingBag: metricsMapInput[key].activeBinsCount,
        };
    }
    return metricsMapOutput;
}

function transformStowBagMetrics(metricsMapInput) {
    const metricsMapOutput = {};
    for (const key in metricsMapInput) {
        metricsMapOutput[key] = {
            plannedBags: metricsMapInput[key].plannedBagCount,
            closedBags: metricsMapInput[key].closedBagCount,
            openBags: metricsMapInput[key].openBagCount,
            usedBags: metricsMapInput[key].usedBagCount,
        };
    }
    return metricsMapOutput;
}

function transformStowCartMetrics(metricsMapInput) {
    const metricsMapOutput = {};
    for (const key in metricsMapInput) {
        metricsMapOutput[key] = {
            plannedCarts: metricsMapInput[key].plannedCartCount,
            usedCarts: metricsMapInput[key].openCartCount,
            missingCarts: metricsMapInput[key].missingCartCount
        };
    }
    return metricsMapOutput;
}

function transformStowAssociateMetrics(associateMetricsGroupList) {
    const metricsMapOutput = {};
    for (const associateMetricsGroup of associateMetricsGroupList) {
        metricsMapOutput[associateMetricsGroup.id] = {
            displayLabel: chainWalk(() => associateMetricsGroup.displayLabel, null),
            activeStowers: chainWalk(() => associateMetricsGroup.associateMetrics.activeCount, null),
            inactiveStowers: chainWalk(() => associateMetricsGroup.associateMetrics.inactiveCount, null)
        };
    }
    return metricsMapOutput;
}

function transformStowFilters(filterMap, capability) {
    let resourceMap = {};
    let resource;
    if(Capability.SSD === capability) {
        resource = Resource.CART_LOCATION
        resourceMap = getZoneToCartLocationMap(filterMap)
    } else {
        resource = Resource.AISLE
        resourceMap = getClusterToAisleMap(filterMap)
    }
    return {clusterAislesMap: resourceMap, allAisles: filterMap[resource], allClusters: Object.keys(resourceMap)};
}

const getClusterToAisleMap = (filterMap) => {
    const clusterAislesMap = {};
    filterMap[Resource.AISLE].forEach(aisle => {
        const cluster = getClusterForAisle(aisle);
        if (!cluster || cluster === "Total") {
            filterMap[Resource.AISLE] = filterMap[Resource.AISLE].filter(function (ele) {
                return ele !== aisle;
            });
            return;
        }
        if (!clusterAislesMap[cluster]) {
            clusterAislesMap[cluster] = [];
        }
        clusterAislesMap[cluster].push(aisle);
    });
    return clusterAislesMap
}

const getZoneToCartLocationMap = (filterMap) => {
    const zoneToCartLocationMap = {}
    filterMap[Resource.CART_LOCATION].forEach(cartLocation => {
        const zoneLabel = getZoneForCartLocation(cartLocation)
        if(filterMap[Resource.ZONE].includes(zoneLabel)) {
            if (!zoneToCartLocationMap[zoneLabel]) {
                zoneToCartLocationMap[zoneLabel] = []
            }
            zoneToCartLocationMap[zoneLabel].push(cartLocation)
        }
    })
    return zoneToCartLocationMap
}

function transformStowFloorMetricsGroupMap(floorMetricsGroupList) {
    const floorMetricsGroupEntries = floorMetricsGroupList
        .map(floorMetricsGroup => ({[floorMetricsGroup.id]: transformStowFloorMetricsGroup(floorMetricsGroup)}));
    return Object.assign({}, ...floorMetricsGroupEntries);
}

function transformStowFloorMetricsGroup(floorMetricsGroup) {
    return {
        displayLabel: floorMetricsGroup.displayLabel,
        floorMetrics: transformStowFloorMetrics(floorMetricsGroup.floorMetrics)
    }
}

function transformStowFloorMetrics(floorMetrics) {
    return {
        floorsCountMissingCart: floorMetrics.floorsCountMissingCart,
        attachedCartCount: floorMetrics.attachedCartCount
    }
}



// WEBPACK FOOTER //
// ./src/resources/StowResource.js